import axios from '../../shared/axiosConfig';
import { push } from 'connected-react-router'
import * as AppActions from './App';
import * as JobActions from './Jobs';
import { valuesToFormData } from '../../shared/utils';

export const AppliesActions = {
  SET_ATTRIBUTE: "APPLIES_SET_ATTRIBUTE",
  RESET_STATE: "APPLIES_RESET_STATE",
  MARK_JOB: "APPLIES_MARK_JOB",
};

/**
 * @param {String} key
 * @param {*} value
 */
export const setAppliesAttribute = (key, value) => {
  return {
    type: AppliesActions.SET_ATTRIBUTE,
    key,
    value
  };
};

export const companiesResetState = () => {
  return {
    type: AppliesActions.RESET_STATE
  }
}

export const markJobApplied = (jobId) => {
  return {
    type: AppliesActions.MARK_JOB,
    key: jobId
  }
}

export const createJobApply = (values) => async (dispatch,getState) => {
  let jobId = getState().jobs.currentJobId;
  let {eventId,companyId} = getState().company;
  console.log(`New job application for job ${jobId} and values `, values);
  dispatch( setAppliesAttribute('inProgress', true) );
  axios.post(`/api/events/${eventId}/companies/${companyId}/jobs/${jobId}/applies`, valuesToFormData(values) )
    .then( async (res) => {
      console.log("Upload completed");
      dispatch( setAppliesAttribute('inProgress', false) );
      dispatch( markJobApplied(jobId) );
    })
    .catch( function(err) {
      console.log(err);
      dispatch( setAppliesAttribute('inProgress', false) );
    });
}
